import {
    DateTimeService,
    DateTimeUtils,
    WallClockDate,
    WallClockDateService,
    DateTimeLocalizationInfo,
} from '@mews/framework/datetime';
import { createCalendarService, StructuredDate } from '@optimus-web/core';

interface CalendarServiceOptions {
    getLocalization: () => DateTimeLocalizationInfo;
    getCurrentDate?: () => StructuredDate;
}

export const createDistributorCalendarService = ({ getLocalization, getCurrentDate }: CalendarServiceOptions) => {
    const isValidDateString = (dateString: string) => WallClockDateService.isValidString(dateString, getLocalization());
    const getStructuredDate = (wcDate: WallClockDate) => ({
        year: WallClockDateService.getYear(wcDate),
        month: WallClockDateService.getMonth(wcDate),
        date: WallClockDateService.getDate(wcDate),
    });
    const getToday = () => getStructuredDate(WallClockDateService.today());
    const fromDateString = (dateString: string, format = getLocalization()) =>
        getStructuredDate(WallClockDateService.fromString(dateString, format));
    const getDateString = (date: StructuredDate) => {
        const wallclockDate = DateTimeUtils.structuredDateToWallClockDate(date);
        return WallClockDateService.toString(wallclockDate, getLocalization());
    };

    return createCalendarService({
        getLocalization,
        isValidDateString,
        getCurrentDate: getCurrentDate || getToday,
        fromDateString,
        getDateString,
        parseDateFromFormat: DateTimeService.fromFormat,
    });
};
